"use strict";
// (C) 2023 GoodData Corporation
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminInformationMessage = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var Messages_1 = require("../../../Messages");
exports.AdminInformationMessage = function (_a) {
    var isVisible = _a.isVisible, onClose = _a.onClose;
    if (!isVisible) {
        return null;
    }
    return (react_1.default.createElement(Messages_1.Message, { type: "progress", className: "gd-granular-permissions-admin-information s-granular-permissions-admin-information", onClose: onClose },
        react_1.default.createElement("span", null,
            react_1.default.createElement(react_intl_1.FormattedMessage, { id: "shareDialog.share.granular.administrator.info", values: { b: function (chunks) { return react_1.default.createElement("strong", null, chunks); } } }))));
};
//# sourceMappingURL=AdminInformationMessage.js.map